module.exports = __webpack_public_path__ + "static/img/img-2.ecefb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-2.png
// module id = tmPC
// module chunks = 1